export default "__VITE_PUBLIC_ASSET__0a56b7d2__"